import React, { useState } from "react";
import { Field } from "redux-form";
import { ALL_STATES as allStates } from "@constants/payfields";
import { getStateAndCityFromZip } from "@actions/customerInfo";
import styled from "@emotion/styled";
import RenderFormFieldNew from "@components/forms/RenderFormFieldNew";
import { FaTimes } from "react-icons/fa";
import loadable from "@loadable/component";
const RenderStateDropdownNew = loadable(() =>
  import(
    /* webpackChunkName: "RenderStateDropdownNew" */ "./forms/RenderStateDropdownNew"
  )
);
import { useDispatch } from "react-redux";
import {
  firstName,
  lastName,
  street,
  city,
  state,
  zip
} from "@components/validation";
const MessageContainer = loadable(() =>
  import(/* webpackChunkName: "MessageContainer" */ "./MessageContainer")
);

const InputWrapperGrid = styled.div`
  position: relative;
  margin-bottom: 18px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 18px;

  @media (max-width: 500px) {
    grid-template-columns: 1fr;
  }
`;

const InputWrapper = styled.div`
  position: relative;
  margin-bottom: 18px;
`;

const AddressLineTwo = styled.div`
  margin-bottom: 10px;
`;

const AddressButton = styled.span`
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  color: #12b2ea;
  margin-bottom: 15px;
  display: block;
  padding-left: 30px;

  @media (max-width: 375px) {
    padding-left: 15px;
  }
  @media (max-width: 300px) {
    padding-left: 8px;
  }
`;

const PlusSpan = styled.span`
  color: rgba(18, 178, 234, 0.4);
`;

const SecondAddressContainer = styled.div`
  margin-bottom: 17px;
  position: relative;
`;

const AbsoluteX = styled.div`
  position: absolute;
  top: 38%;
  right: 17px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  box-shadow: 0 6px 12px 0 rgba(31, 32, 33, 0.1);
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const FieldGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 30px;
  margin-bottom: 17px;

  @media (max-width: 375px) {
    grid-template-columns: 1fr;
    grid-gap: 17px;
  }
`;

const CustomerAddressForm = ({ errorFromServer, formData }) => {
  const dispatch = useDispatch();

  if (!formData) return null;
  const [secondAddress, changeSecondAddress] = useState(
    formData?.street2 ? true : false
  );
  const [valuesFromZip, setValuesFromZip] = useState({});

  const handleZip = async e => {
    const values = await dispatch(getStateAndCityFromZip(e));
    setValuesFromZip(values);
  };

  return (
    <>
      {errorFromServer && (
        <div>
          <MessageContainer
            message={errorFromServer}
            classes={"credit-card-form-error-message"}
          />
        </div>
      )}
      <InputWrapperGrid>
        <Field
          name="firstname"
          component={RenderFormFieldNew}
          type="text"
          placeholder="First Name"
          validate={firstName}
        />
        <Field
          name="lastname"
          component={RenderFormFieldNew}
          type="text"
          placeholder="Last Name"
          validate={lastName}
        />
      </InputWrapperGrid>
      <InputWrapper>
        <Field
          name="street"
          component={RenderFormFieldNew}
          type="text"
          placeholder="Address"
          validate={street}
        />
      </InputWrapper>
      <AddressLineTwo>
        {!secondAddress && (
          <AddressButton onClick={() => changeSecondAddress(!secondAddress)}>
            <PlusSpan>+</PlusSpan> Add Street Address Line 2
          </AddressButton>
        )}
        {secondAddress && (
          <SecondAddressContainer>
            <Field
              name="street2"
              label="street2"
              component={RenderFormFieldNew}
              type="text"
              placeholder="Address Line 2"
            />
            <AbsoluteX onClick={() => changeSecondAddress(!secondAddress)}>
              <FaTimes
                style={{ color: "rgba(31, 32, 33, 0.4)", fontSize: "12px" }}
              />
            </AbsoluteX>
          </SecondAddressContainer>
        )}
      </AddressLineTwo>
      <InputWrapper>
        <Field
          name="city"
          component={RenderFormFieldNew}
          type="text"
          placeholder="City"
          validate={city}
          valuesFromZip={valuesFromZip ? valuesFromZip.city : ""}
        />
      </InputWrapper>
      <FieldGrid>
        <Field
          name="state"
          label="state"
          component={RenderStateDropdownNew}
          type="text"
          placeholder="State"
          list={allStates}
          validate={state}
          valuesFromZip={valuesFromZip ? valuesFromZip.state : ""}
        />

        <Field
          name="zip"
          label="zip"
          component={RenderFormFieldNew}
          type="text"
          placeholder="ZIP"
          validate={zip}
          handleZip={handleZip}
        />
      </FieldGrid>
    </>
  );
};

export default CustomerAddressForm;
